import { type MouseEvent, memo, useCallback } from 'react';

import { Link2Icon } from '@air/design-icons';

export type WorkspaceAgentShareLinkPreviewUrlRowProps = {
  displayUrl: string;
  onCopyLink: () => void;
};

/** The row is the copy control. The card body is not a button, so this one can be. */
export const WorkspaceAgentShareLinkPreviewUrlRow = memo(
  ({ displayUrl, onCopyLink }: WorkspaceAgentShareLinkPreviewUrlRowProps) => {
    const handleCopyLink = useCallback(
      (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onCopyLink();
      },
      [onCopyLink],
    );

    return (
      <button
        aria-label={`Copy share link ${displayUrl}`}
        className="group flex w-full min-w-0 cursor-pointer items-center gap-1 rounded-4 text-left ads:text-metadata text-[11px] text-gray-10 leading-4 ads:hover:text-primary hover:text-gray-12 focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-altitude-8"
        data-testid="WORKSPACE_AGENT_SHARE_LINK_PREVIEW_URL_ROW"
        onClick={handleCopyLink}
        type="button"
      >
        <Link2Icon aria-hidden className="shrink-0" size="xs" />
        <span
          className="min-w-0 truncate underline-offset-2 group-hover:underline"
          data-testid="WORKSPACE_AGENT_SHARE_LINK_PREVIEW_URL"
        >
          {displayUrl}
        </span>
      </button>
    );
  },
);

WorkspaceAgentShareLinkPreviewUrlRow.displayName = 'WorkspaceAgentShareLinkPreviewUrlRow';
